import fonts from './fonts'
import colors from './colors'
import applicationStyles from './applicationStyles'

export default {
	fonts,
  colors,
	applicationStyles,
}


// WEBPACK FOOTER //
// ./src/themes/index.js